export const categoryIcons: Record<string, string> = {
  "vloerverwarming-ds": "cbi:underfloor-heating",
  "wd-40": "formkit:tools",
  "automotive": "automotive:circle",
  "bevestigingsmiddelen": "bevestigingsmiddelen:screw", 
  "elektriciteit": "elektriciteit:plug",
  "opbergen": "opbergen:toolkit",
  "verwarming-ventilatie": "uil:ventilator",
  "verwarming": "uil:ventilator",
  "opop": "op-op:rounded",
  "sanitair": "sanitair:bath",
  "deals": "mynaui:percentage-waves",
  "schroeven-bevestigingsmiddelen": "mdi:screw-round-top",
  "elektrisch-gereedschap": "material-symbols:tools-power-drill-outline",
  "elektra": "icons8:electrical",
  "gereedschap-accessoires": "carbon:tool-kit",
  "handgereedschap": "mingcute:screwdriver-line",
  "hang-sluitwerk": "tabler:lock-filled",
  "kranen-douches": "cil:shower",
  "ijzerwaren": "material-symbols:hardware-outline-sharp",
  "installatie": "codicon:tools",
  "lijmen-kitten-tapes": "la:tape",
  "tuingereedschap": "tabler:shovel",
  "verf-accessoires": "octicon:tools-24",
  "verlichting": "tdesign:lighting-circle",
  "werkkleding-pbm": "healthicons:ppe-suit-outline",
  "werkplaats": "pajamas:work",
  "reinigen-onderhoud": "healthicons:cleaning-outline",
  "uitverkoop": "foundation:burst-sale",
};